import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import PageableCollection from '@/backbone/PageableCollection';
import { DateCell } from '@/backgrid/MomentCell';

const CommandInventoryGridView = GridView.extend({
  className: 'command-inventory-grid',

  initialize() {
    const columns = [
      {
        name: 'asset',
        label: 'Asset',
        cell: StringCell,
        headerCell: 'custom',
        width: 5,
        editable: false,
        sortable: true
      },
      {
        name: 'serialNumber',
        label: 'Serial Number',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'inventoryNumber',
        label: 'Inventory Number',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'location',
        label: 'Location',
        cell: StringCell,
        headerCell: 'custom',
        width: 30,
        editable: false,
        sortable: true
      },
      {
        name: 'subLocation',
        label: 'Sub Location',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: 'facilityText',
        label: 'Facility Text/Command',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'plant',
        label: 'Plant',
        cell: StringCell,
        headerCell: 'custom',
        width: 5,
        editable: false,
        sortable: true
      },
      {
        name: 'vendor',
        label: 'Vendor Cage Code',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'manufacturer',
        label: 'Manufacturer',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'orgAquisYear',
        label: 'Org Aquis Year',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'originalValue',
        label: 'Original Value',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true,
        renderable: !EXTERNAL
      },
      {
        name: 'make',
        label: 'Make',
        cell: StringCell,
        headerCell: 'custom',
        width: 5,
        editable: false,
        sortable: true
      },
      {
        name: 'model',
        label: 'Model',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'contractAwardDate',
        label: 'Contract Award Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'contractEndDate',
        label: 'Contract End Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'eqInstallDate',
        label: 'Eq Install Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'uninstallDate',
        label: 'Uninstall Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'piin',
        label: 'PIIN/SPIN',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true,
        renderable: !EXTERNAL
      },
      {
        name: 'clin',
        label: 'CLIN',
        cell: StringCell,
        headerCell: 'custom',
        width: 5,
        editable: false,
        sortable: true
      },
      {
        name: 'miprNumber',
        label: 'MIPR Number',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'material',
        label: 'Material',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'miprCode',
        label: 'MIPR Code',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'leaseTerm',
        label: 'Lease Term',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'name',
        label: 'POC Name',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'email',
        label: 'POC Email',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'phone',
        label: 'POC Phone',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'sellingPrice',
        label: 'Selling Price',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      }
    ];

    this.options.columns = columns;
    this.options.collection = new PageableCollection(this.model.get('assets'));
    this.options.width = '5000px';
    this.options.emptyText = 'No Command Inventory Found';
  }
});

export default CommandInventoryGridView;
